
import { Component, Vue } from "vue-property-decorator";
import Sidebar from "@/components/navigations/sidebar.vue";
import tag from "@/components/tags/Tag.vue";
import PanelOption from "@/components/option/option.vue";
import cta from "@/components/buttons/Button.vue";
import { quizz } from "@/store";
import { found, select } from "@/helpers";

@Component({
  methods: {
    found,
    select,
  },
  components: {
    Sidebar,
    tag,
    PanelOption,
    cta,
  },
})
export default class VerificationAssistee extends Vue {
  private dataReady = false;
  private codeQuizz = "";

  async mounted(): Promise<void> {
    await quizz.quizzs();
    this.dataReady = true;
  }

  get quizzs(): any[] | null {
    return quizz.getQuizzs;
  }
}
